import EmptyImagesListIcon from '@/common/assets/icons/emptyImagesList.svg?react';
import Button from '@/common/components/base/button/Button';
import SignatureDrawingPad from '@/common/components/base/signatureCanvas/instances/SignatureDrawingPad';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import Typography from '@/common/components/base/typography/Typography';
import FixToBottom from '@/common/components/layouts/FixToBottom';
import LoadingPage from '@/common/pages/LoadingPage';
import SignatureConfirmationModal from '@/modules/adjusterReportModules/components/damagedSignature/SignatureConfirmationModal';
import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';
import {
  FileFaEnum,
  SignatureViewProps,
} from '@/modules/adjusterReportModules/components/SignatureView/SignatureView.type';
import useModal from '@/common/hooks/useModal';
import SignatureEditModalWrapper from '@/modules/adjusterReportModules/components/damagedSignature/SignatureEditModal';

const SignatureView = ({
  isLoading,
  signatureImage,
  editable,
  signatureProps,
  onOpenConfirmation,
  confirmationOpen,
  onCloseConfirmation,
  onSubmitSignature,
  postLoading,
  patchLoading,
  type,
}: SignatureViewProps) => {
  if (isLoading) {
    return <LoadingPage />;
  }

  const { closeModal, open, openModal } = useModal();
  return (
    <Box pt="1.5rem">
      <TitleDescription>ثبت امضا</TitleDescription>
      {signatureImage && editable && (
        <Box>
          <Typography textStyle="b2" color="black-1" mt="1.5rem">
            {` کارشناس محترم، تصویر امضا ${FileFaEnum[type]} را می توانید در کادر زیر مشاهده کنید.
`}{' '}
          </Typography>
          <Box
            className={css({
              width: '100%',
              maxWidth: 'maxContainer',
              mx: 'auto',
              backgroundColor: 'white',
              p: '8px',
              borderRadius: '8px',
              mt: '1.5rem',
              boxShadow: 'cardShadow',
            })}
          >
            <img
              src={signatureImage}
              alt=""
              className={css({
                width: '100%',
                maxWidth: '300px',
                mx: 'auto',
                mt: '1rem',
                border: '1px solid',
                borderColor: 'gray-2',
                borderRadius: '8px',
              })}
            />
          </Box>
          <FixToBottom>
            <Button variant="outlined" onClick={openModal} fullWidth>
              ویرایش امضا{' '}
            </Button>
          </FixToBottom>
        </Box>
      )}
      {signatureImage && !editable && (
        <Box>
          <Typography textStyle="b2" color="black-1" mt="1.5rem">
            {`کارشناس محترم، تصویر امضا ${FileFaEnum[type]} را می توانید در کادر زیر مشاهده کنید.
`}{' '}
          </Typography>
          <Box
            className={css({
              width: '100%',
              maxWidth: 'maxContainer',
              mx: 'auto',
              backgroundColor: 'white',
              p: '8px',
              borderRadius: '8px',
              mt: '1.5rem',
              boxShadow: 'cardShadow',
            })}
          >
            <img
              src={signatureImage}
              alt=""
              className={css({
                width: '100%',
                maxWidth: '300px',
                mx: 'auto',
                mt: '1rem',
                border: '1px solid',
                borderColor: 'gray-2',
                borderRadius: '8px',
              })}
            />
          </Box>
        </Box>
      )}
      {!signatureImage && editable && (
        <>
          <Typography textStyle="b2" color="black-1" mt="1.5rem">
            {`کارشناس محترم ، از ${FileFaEnum[type]} بخواهید امضای خود را در کادر زیر ترسیم کند.
`}{' '}
          </Typography>

          <SignatureDrawingPad {...signatureProps} />

          <FixToBottom>
            <Button
              onClick={onOpenConfirmation}
              disabled={signatureProps.isEmpty}
              fullWidth
            >
              ثبت
            </Button>
          </FixToBottom>
        </>
      )}{' '}
      {!signatureImage && !editable && (
        <Box mt="100px">
          <EmptyImagesListIcon className={css({ mx: 'auto' })} />
        </Box>
      )}
      <SignatureConfirmationModal
        onSubmit={() => {
          (onSubmitSignature(), closeModal());
        }}
        closeModal={onCloseConfirmation}
        open={confirmationOpen}
        loading={signatureImage ? patchLoading : postLoading}
      />
      <SignatureEditModalWrapper
        signatureProps={signatureProps}
        onOpenConfirmation={onOpenConfirmation}
        closeModal={closeModal}
        open={open}
        type={type}
      />
    </Box>
  );
};

export default SignatureView;
